<template>
  	<div class="stores">
		<div style="padding:10px 0">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>课程管理</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/trainingPlan' }">课程列表</el-breadcrumb-item>
				<el-breadcrumb-item>{{this.queryType == 2?'修改':'创建'}}训练计划</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
	    <div class="traingplan" style="padding-top:10px;">
			<el-table border :data="tableData" style="width: 100%" ref="multipleTable">
		        <el-table-column label="周" align="center">
			        <template slot-scope="scope">
			            <span>第{{scope.row.weekOrder}}周</span>
			        </template>
		        </el-table-column>
		        <el-table-column label="天">
		          	<template slot-scope="scope">
						<span>第{{scope.row.dayOrder}}天</span>
		        	</template>
		        </el-table-column>
		        <el-table-column label="课程名称">
		          	<template slot-scope="scope">
		            	<span>{{scope.row.courseName}}</span>
		          	</template>
		        </el-table-column>
				<el-table-column label="教练名称">
		          	<template slot-scope="scope">
		            	<span>{{scope.row.coachName}}</span>
		          	</template>
		        </el-table-column>
				<el-table-column label="课程消耗">
		          	<template slot-scope="scope">
		            	<span>{{scope.row.courseCalorie}}</span>
		          	</template>
		        </el-table-column>
				<el-table-column label="目标消耗">
		          	<template slot-scope="scope">
		            	<span>{{targetId == 1?scope.row.dayBurnCalorie:'-'}}</span>
		          	</template>
		        </el-table-column>
		        <el-table-column prop="strength" label="选择课程" >
		          	<template slot-scope="scope">
		            	<el-button v-if="scope.row.courseId" type="primary" size="medium" @click="chageClass(scope.$index)">选择课程</el-button>
		          	</template>
		        </el-table-column>
	      	</el-table>
	    </div>
		<el-dialog title="教练列表" :visible.sync="dialog" width="70%" top="10px">
			<div v-loading="loading">
				<div class="hall-search-list">
					<span class="hall-search-name">课程名称</span>
					<input type="text" style="width:20%;" placeholder="请输入课程名称" class="el-input__inner" v-model="query.nickname" @keyup.enter="getCoachList()"/>
					<span class="hall-search-name">教练名称</span>
					<input type="text" style="width:20%;" placeholder="请输入教练名称" class="el-input__inner" v-model="query.userId" @keyup.enter="getCoachList()"/>
					<span class="hall-search-name">课程时间</span>
					<el-date-picker
						v-model="query.timeVal"
						type="daterange"
						range-separator=" 至 "
						start-placeholder="课程开始日期"
						end-placeholder="课程结束日期"
						value-format="yyyy-MM-dd">
					</el-date-picker>
					<span class="hall-search-line"></span>
	    			<el-button type="primary" @click="getCoachList()">搜索</el-button>
	    			<el-button type="warning" @click="result()">重置</el-button>
				</div>
				<div style="padding:10px 0">
					<el-tabs v-model="activeName" @tab-click="topnav">
						<el-tab-pane label="全部" name="-1"></el-tab-pane>
						<el-tab-pane v-for="(item,index) in selData" :key="index" :label="item.name" :name="index+''"></el-tab-pane>
					</el-tabs>
				</div>
				<el-table :data="tableData1"
                      border
                      ref="multipleTable"
                      header-cell-class-name="table-header">
				<el-table-column label="课程教练" align="center">
                    <template slot-scope="scope">{{scope.row.coachName}}</template>
                </el-table-column>
				<el-table-column label="课程名称" align="center">
                    <template slot-scope="scope">{{scope.row.name}}</template>
                </el-table-column>
				<el-table-column label="课程类型" align="center">
                    <template slot-scope="scope">{{scope.row.courseKindName}}</template>
                </el-table-column>
				<el-table-column label="消耗" align="center">
                    <template slot-scope="scope">{{scope.row.calories}}</template>
                </el-table-column>
				<el-table-column label="训练压力" align="center">
                    <template slot-scope="scope">{{scope.row.tss}}</template>
                </el-table-column>
				<el-table-column label="强度因子" align="center">
                    <template slot-scope="scope">{{scope.row.vi}}</template>
                </el-table-column>
				<el-table-column label="课程时长" align="center">
                    <template slot-scope="scope">{{scope.row.duration}}</template>
                </el-table-column>
                <el-table-column label="操作" width="210" align="center">
                    <template slot-scope="scope">
                        <el-button
                                    @click="examine(scope.row)"
                                   type="text"
                                   size="small"
                                   icon="el-icon-s-claim">选择此课程</el-button>
						<el-button
                                    @click="seeVideo(scope.row)"
                                   type="text"
                                   size="small"
                                   icon="el-icon-s-claim">视频预览</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination layout="sizes,total, prev, pager, next, jumper"
                               :current-page="query.pageIndex"
                               :page-size="query.pageSize"
                               :page-sizes="[10, 50, 100]"
                               @size-change="handleSizeChange"
                               :total="pageTotal"
                               @current-change="handlePageChange"></el-pagination>
            </div>
	    </div>
    </el-dialog>
	<el-dialog title="课程视频" :visible.sync="dialog1" width="50%" top="10%" :before-close="originaClose">
		<video :src="originalVideoHigh" autoplay controls style="width:100%;height:500px;" ref="originaVideo"></video>
	</el-dialog>
  	</div>
</template>

<script>
import ImgUpload from '@/components/ImgUpload';
export default {
  	components: {ImgUpload},
	mounted() {
		this.queryType=this.$route.query.type;
		if(this.queryType == 1){ //新增

		}else if(this.queryType == 2){//编辑
			this.id=this.$route.query.id;
			this.init();
		}
		this.sportsKind()
	},
  	data() {
    	return {
			query:{
				pageIndex:0,
				pageSize:10,
				userId:'',
				sportsKindId:0,
				nickname:'',
				timeVal:[],
				coachId:''
			},
			targetId:'',
			pageTotal:0,
			queryType:1,
			id:'',
			activeName:'-1',
			selData:[],
			dialog:false,
			dialog1:false,
			loading:false,
			tableData: [],
			tableData1: [],
			classIndex:'',
			originalVideoHigh:''
    	};
  	},
  	methods: {
		seeVideo(e){
			console.log('e',e);
			this.originalVideoHigh=e.originalVideoHigh;
			this.dialog1=true;
		},
		originaClose(done){
			this.$refs['originaVideo'].pause();
			done();
		},
		examine(data){
			const updateData=this.tableData[this.classIndex];
			 this.$confirm('是否继续此操作？', '提示', {type: 'success'})
			 .then(() => {
				const loading = this.$loading({ text: "加载中..." });
				this.$post('/plan/package/detail/update', {
					"courseId": data.id,
					"id": this.id,
					"oldCourseId": updateData.courseId,
					"packageDetailId": updateData.id
				}).then((res) => {
					if (res.code == 0) {
						this.$message.success("操作成功");
						this.dialog=false;
						this.init()
					} else {
						this.$message.error(JSON.stringify(res.message));
					}
					loading.close();
				}).catch(err=>{
					this.$message.error(JSON.stringify(err));
					loading.close();
				})
			})
			
		},
		chageClass(index){
			this.classIndex=index;
			this.result()
			this.dialog=true;
		},
		result(){
			this.query.pageIndex=1;
			this.query.nickname='';
			this.query.timeVal=[];
			this.getCoachList();
		},
		handleSizeChange(val){
			this.query.pageSize=val;
			this.getCoachList()
		},
		handlePageChange(val){
			this.query.pageIndex=val;
			this.getCoachList()
		},
	    //初始化表格数据
	    init() {
	      	this.$get("/plan/package/detail",{planPackageId:this.id})
	        .then(res => {
	        	console.log(res)
	          	if (res.code == 0) {
					let list=Array.isArray(res.data.planPackageDetailVoList)?res.data.planPackageDetailVoList:[];
					this.tableData=list;
					this.targetId=res.data.targetId
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
		        }
	        })
	    },
		topnav() {
            let index=Number(this.activeName);
            this.query.sportsKindId=index === -1?0:(Array.isArray(this.selData) && this.selData.length>0?this.selData[index].id:0)
            this.query.pageIndex = 1;
            this.getCoachList();
        },
		getCoachList() {
            this.loading=true;
			const {pageIndex,pageSize,userId,sportsKindId,nickname,timeVal,coachId}=this.query;
            this.$get('/course/getTrainingPlanCourseList', {
				pageNum: pageIndex,
                limit: pageSize,
                coachName: userId,
                sportsKindId: sportsKindId,
                courseName: nickname,
				coachId:coachId,
				courseStartTime:Array.isArray(timeVal) && timeVal.length>1?this.$moment(timeVal[0]).valueOf():'',
				courseEndTime:Array.isArray(timeVal) && timeVal.length>1?this.$moment(timeVal[1]).valueOf():''
			}).then(res => {
                    if (res.code == 0) {
                        this.tableData1 = Array.isArray(res.data.list)?res.data.list:[];
                        this.pageTotal = this.$_.isNumber(res.data.total)?res.data.total:0;
                    } else {
                        this.$message.error(JSON.stringify(res.message));
                        
                    }
					this.loading=false;
                })
                .catch((err) => {
                    console.log(err);
					this.loading=false;
                });
        },
	    create(flag){
			if (flag == 1) {
                this.$router.back();
				return false;
            }
	    	let test = this.testMethod();
            if (!test.flag) {
                this.$message.error(test.msg);
                return false;
            }
			let url=this.queryType==1?'plan/package/create':'';
	        const loading = this.$loading({ text: "加载中..." });
			this.$post(url, test.data).then((res) => {
				if (res.code == 0) {
					this.$message.success("操作成功");
					this.$router.back();
				} else {
					this.$message.error(JSON.stringify(res.message));
				}
				loading.close();
			}).catch(err=>{
				this.$message.error(JSON.stringify(err));
				loading.close();
			})
	    },
		//选择运动种类
        sportsKind() {
            this.$get('/course/sportsKind', {})
			.then(res => {
				console.log(res);
				if (res.code == 0) {
					this.selData = Array.isArray(res.data)?res.data:[];
				} else {
					this.$message.error(JSON.stringify(res.message));
				}
			})
			.catch(() => {
				console.log();
			});
        },
  	}
};
</script>

<style scoped>
::deep
.avatar-uploader-icon {
    width: 108px;
    line-height: 108px
}
::deep
.el-progress-circle{
	width: 108px;
    line-height: 108px;
    height: 108px;
}
.traingplan{
	font-size: 13px;
}
.operation{
	cursor: pointer;
	font-size: 22px
}
.topinput{
	margin-right: 10px;
}
.el-date-editor .el-range-separator{
	padding: 0
}
</style>




// WEBPACK FOOTER //
// src/views/coursesList/trainingPlan/addTrainingPlan.vue